'use client';
import { jsx } from 'react/jsx-runtime';
import { ZoomControlsContextProvider } from './zoom-controls.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(o, r) {
    if (null == o) return {};
    var t, e, n = _object_without_properties_loose(o, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(o);
        for(e = 0; e < s.length; e++)t = s[e], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (n[t] = o[t]);
    }
    return n;
}
function _object_without_properties_loose(o, r) {
    if (null == o) return {};
    var t, e, n = {}, s = Object.keys(o);
    for(e = 0; e < s.length; e++)t = s[e], r.indexOf(t) >= 0 || (n[t] = o[t]);
    return n;
}
const ZoomControls = renderWithRef('ZoomControls', null, (t, c)=>{
    var { children: l } = t, m = _object_without_properties(t, [
        "children"
    ]);
    return useComponentStylesLoaded('ZoomControls', SWAN_STYLE_KEY_MAP.zoomControls), jsx(ZoomControlsContextProvider, {
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: c,
            classNames: [
                'swan-zoom-controls'
            ],
            props: m,
            children: l
        })
    });
});

export { ZoomControls };
